module.exports = __webpack_public_path__ + "assets/img/hero-bg.3900fb58.png";